<template>
  <v-row align="center" justify="center">
    <v-col cols="12" md="6">
      <SectionTitle>Disparador de Whatsapp em Massa:</SectionTitle>

      <ul class="benefits-list mt-8">
        <li
          v-for="(item, i) in items"
          :key="i"
          class="benefit-item"
          :style="{ animationDelay: `${i * 0.12}s` }"
        >
          <div class="benefit-icon-wrap">
            <v-icon color="success" size="18">mdi-check</v-icon>
          </div>
          <span>{{ item }}</span>
        </li>
      </ul>

      <CtaButton class="mt-8">Quero vender mais</CtaButton>
    </v-col>

    <v-col cols="12" md="6" class="position-relative">
      <v-img
        :src="require('@/assets/images/mass-whatsapp.png')"
        alt="Disparo de mensagens em massa pelo WhatsApp no ZaperMenu"
        aspect-ratio="1"
        class="rounded-img"
      />
    </v-col>
  </v-row>
</template>

<script>
  import CtaButton from "@/components/CtaButton.vue";
  import SectionTitle from "@/components/SectionTitle.vue";

  export default {
    name: "MassWhatsappSection",

    components: {
      CtaButton,
      SectionTitle,
    },

    data: () => ({
      items: [
        'Envie mensagens para todos os contatos',
        'Recupere clientes inativos',
        'Impulsione as vendas e aumente o faturamento',
      ],
    }),
  };
</script>

<style scoped lang="scss">
  .benefits-list {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .benefit-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 18px;
    border-radius: 14px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: var(--text-secondary);

    opacity: 0;
    animation: benefit-appear 0.45s ease-out forwards;

    transition: border-color 0.25s, transform 0.25s;
    &:hover {
      border-color: rgba(35, 207, 101, 0.5);
      transform: translateX(4px);
    }

    @media (max-width: 768px) {
      font-size: 15px;
      padding: 12px 14px;
    }
  }

  .benefit-icon-wrap {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(35, 207, 101, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rounded-img {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4);
  }

  @keyframes benefit-appear {
    from {
      opacity: 0;
      transform: translateX(-18px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .section-title {
    font-size: 40px;
    line-height: 64px;
    @media (max-width: 780px) {
      font-size: 28px;
      line-height: 36px;
    }
  }
</style>
